module.exports = __webpack_public_path__ + "Flag-48.1769bc9c8fe0ee38022f4e740c4d9a94.svg";